const moduleState = () => {
  return {
    allUserRoles: {},
  }
}
const getters = {
  get: (state) => state.allUserRoles,
}

const mutations = {
  setAllUserRoles: (state, payload) => {
    if (!payload) {
      state.allUserRoles = {}

      return
    }

    state.allUserRoles = payload
  },
}

const actions = {
  setAllUserRoles: ({ commit }, payload) => {
    commit('setAllUserRoles', payload)
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
